import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Avatar,
  Box,
  CircularProgress,
} from "@mui/material";
import { updateVehicle } from "../../services/vehicleService";
import SuccessMessageModal from "../Reusable/SuccessMessageModal";
import WarningMessageModal from "../Reusable/WarningMessageModal";

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const EditVehiculoModal = ({ isOpen, onClose, vehiculo }) => {
  const [vehicleData, setVehicleData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    if (vehiculo) {
      setVehicleData({
        plate: vehiculo.plate || "",
        model: vehiculo.model || "",
        charger_type: vehiculo.charger_type || "",
        photo: vehiculo.photo || "",
      });
    }
  }, [vehiculo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVehicleData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setVehicleData(prev => ({...prev, photo: URL.createObjectURL(e.target.files[0])}));
    }
  };

  const handleSave = async () => {
    if (!vehicleData.plate) {
      setModalMessage("La placa es obligatoria.");
      setIsWarningOpen(true);
      return;
    }

    setIsLoading(true);
    const dataToSubmit = { ...vehicleData };

    if (selectedFile) {
      dataToSubmit.photo = await toBase64(selectedFile);
    }

    try {
      await updateVehicle(vehiculo.vehicle_id, dataToSubmit);
      setModalMessage("Vehículo actualizado exitosamente.");
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error al actualizar el vehículo.";
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onClose(true);
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)}>
      <DialogTitle>Editar Vehículo</DialogTitle>
      <DialogContent>
        {isLoading ? <Box display="flex" justifyContent="center"><CircularProgress /></Box> : (
            <>
                <TextField margin="dense" label="Placa *" name="plate" fullWidth value={vehicleData.plate} onChange={handleChange} />
                <TextField margin="dense" label="Modelo" name="model" fullWidth value={vehicleData.model} onChange={handleChange} />
                <FormControl fullWidth margin="dense">
                    <InputLabel>Tipo de Cargador</InputLabel>
                    <Select name="charger_type" value={vehicleData.charger_type} onChange={handleChange} label="Tipo de Cargador">
                        <MenuItem value="Tipo 1">Tipo 1</MenuItem>
                        <MenuItem value="Tipo 2">Tipo 2</MenuItem>
                    </Select>
                </FormControl>
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Button variant="contained" component="label">
                        Cambiar Foto
                        <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
                    </Button>
                    {vehicleData.photo && <Avatar src={vehicleData.photo} sx={{ width: 100, height: 100, mt: 2 }} />}
                </Box>
            </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" disabled={isLoading}>Guardar Cambios</Button>
      </DialogActions>
      <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
      <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </Dialog>
  );
};

export default EditVehiculoModal;
